<template>
  <div class="Rooms bg">
    <Header>
      <template v-slot:default>
        <div class="rooms-topbar">
          <div class="rooms-topbar__left">
            <div class="form-group mb-0">
              <input
                type="text"
                class="form-control rooms-search"
                placeholder="Search Room"
                v-model="searchroom"
                @input="SearchRoom()"
                name="name_register"
                id="name_register"
              />
            </div>
          </div>

          <div class="rooms-topbar__right">
            <button
              v-if="addingNewRoomVisible"
              class="cancelbutton"
              @click="cancelAddingRoom"
            >
              Cancel Adding Room
            </button>

            <button
              v-if="OrdersCount > 0"
              class="checkout"
              @click="$router.push('/rooms-booking')"
              aria-label="Go to booking cart"
              title="Bookings"
            >
              <i class="icon_cart"></i>
              <span class="checkout__count">{{ OrdersCount }}</span>
            </button>
          </div>
        </div>
      </template>
    </Header>

    <div class="filters_full clearfix add_bottom_15 page_header"></div>

    <div class="margin_30_40 container-fluid" v-if="roomsData">
      <h5 v-if="$route.query.type" class="mt-3 ml-3">
        Showing: <strong>{{ $route.query.type }}</strong> Rooms
      </h5>
      <div class="row">
        <div class="col-lg-12">
          <div class="row" v-if="roomsData.length == 0">
            <div class="col">
              <p
                style="
                  color: #c53a2a;
                  background: #00808073 none repeat scroll 0% 0%;
                  padding: 20px;
                  font-size: 16px;
                  border-radius: 20px;
                "
              >
                no results found
              </p>
            </div>
          </div>
          <div class="row">
            <div
              class="col-xl-3 col-lg-6 col-md-6 col-sm-6"
              v-for="(i, index) in roomsData"
              :key="index"
            >
              <CModal
                Text="customize"
                ref="RoomSingleModal"
                headerText="Room"
                :width="850"
                submitText="Book"
                :hideButton="true"
                @onClickSubmit="PrintKitchenTicket"
                :visibleFooter="false"
                :modalName="'modal-' + i.id"
              >
                <template v-slot:content>
                  <SingleRoomViewForm
                    :Room="roomsDatasingleView"
                    :RoomImages="RoomImagesData"
                    :RoomTypes="RoomTypesData"
                  />
                </template>
              </CModal>
              <CModal
                Text="customize"
                ref="AddmoreRoom"
                headerText="Room"
                :width="850"
                submitText="Book"
                :hideButton="true"
                @onClickSubmit="PrintKitchenTicket"
                :visibleFooter="false"
                :modalName="'modal-addmore' + i.id"
              >
                <template v-slot:content>
                  <Room
                    :item="roomsDatasingleView"
                    :RoomImages="RoomImagesData"
                    :FilterDate="FilterDate"
                    :ReservationId="addingNewRoomReservationId"
                  />
                </template>
              </CModal>
              <div
                class="strip room-strip"
                @click="
                  !isAlreadyBooked(i.id)
                    ? SingleRoomView(
                        i.id,
                        'modal-' + i.id,
                        'modal-addmore' + i.id
                      )
                    : ''
                "
              >
                <figure>
                  <span v-if="isAlreadyBooked(i.id)" class="ribbon off"
                    >Booked</span
                  >
                  <!-- {{i.images}} -->
                  <Courosel
                    v-if="i.images.length > 0"
                    :images="i.images"
                    class="p-0"
                    :class="{ booked: isAlreadyBooked(i.id) }"
                  />

                  <img
                    v-else
                    src="../assets/room2.jpg"
                    data-src="img/table.jpg"
                    class="img-fluid lazy"
                    alt=""
                  />
                  <div class="strip_info" aria-hidden="true">
                    <div class="item_title">
                      <h3 class="room-name">{{ i.name }}</h3>
                    </div>
                  </div>
                </figure>

                <ul class="text-left">
                  <li class="room-meta">
                    <span class="room-meta__label">Type</span>
                    <span class="room-meta__value">
                      <span
                        v-for="rt in i.roomTypes"
                        :key="rt.id"
                        class="room-badge"
                      >
                        {{ rt.name }}
                      </span>
                    </span>
                  </li>
                  <li class="room-meta">
                    <span class="room-meta__label">Smoking</span>
                    <span class="room-meta__value">
                      <strong>{{
                        i.is_smoking ? "Allowed" : "Not Allowed"
                      }}</strong>
                    </span>
                  </li>
                  <li class="room-meta">
                    <span class="room-meta__label">Floor</span>
                    <span class="room-meta__value">
                      <strong>{{ (i.floor && i.floor.name) || "-" }}</strong>
                    </span>
                  </li>

                  <li class="room-actions">
                    <button
                      class="room-cta"
                      :class="{ 'room-cta--disabled': isAlreadyBooked(i.id) }"
                      :disabled="isAlreadyBooked(i.id)"
                      @click.stop="
                        !isAlreadyBooked(i.id) &&
                          SingleRoomView(
                            i.id,
                            'modal-' + i.id,
                            'modal-addmore' + i.id
                          )
                      "
                    >
                      <i class="icon_cart_alt"></i>
                      {{ isAlreadyBooked(i.id) ? "Booked" : "Book Now" }}
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <!-- /strip grid -->
          </div>
          <!-- /row -->
        </div>
        <!-- /col -->
      </div>
    </div>
    <div class="banner version_2"></div>
  </div>
</template>

<script>
import Courosel from "@/components/base/Caurosel/index";
import Room from "./SingleRoom";

const MyComponent = {
  template: `
        <span class="my-icon">{{ opened ? 'I am open' : ' I am closed' }}</span>
    `,
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
};
import { CustomModal as CModal } from "@/components/base/index.js";
import SingleRoomViewForm from "../components/Share/SingleRoomView/index";
import CheckboxList from "../components/Share/CheckboxList/index";
import VueRangeSlider from "vue-range-component";
import "vue-range-component/dist/vue-range-slider.css";
import axios from "@/plugins/axios";
import { Header } from "@/components/index.js";
import { RefreshButton } from "@/components/index.js";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import { getBrandSliderStyles } from "@/utils/kotTheme";
export default {
  name: "Home",
  data() {
    return {
      selected: {
        key: "1",
        text: "select",
      },
      completeBill: false,
      selectedMethod: {
        key: "1",
        text: "select",
      },
      iconComponent: MyComponent,
      typesLoaded: false,
      RoomImagesData: [],
      RoomTypesData: [],
      roomsDataImages: [],
      roomsData: [],
      searchroom: "",
      roomsDatasingleView: [],
      roomTypes: [],
      range: 1000,
      rangeBackground: {
        // backgroundColor: "#fff",
        // boxShadow: "inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)",
      },
    };
  },

  components: {
    VueRangeSlider,
    Header,
    CModal,
    CheckboxList,
    Courosel,
    RefreshButton,
    SingleRoomViewForm,
    Room,
  },
  computed: {
    ...mapState("sitesetting", ["setting"]),
    ...mapGetters("orders", ["bookedRoomsIdList"]),
    ...mapGetters("orders", ["OrdersCount"]),
    ...mapState("orders", ["FilterDate"]),
    ...mapState("orders", ["addingNewRoomVisible"]),
    ...mapState("orders", ["addingNewRoomReservationId"]),
    processStyle() {
      return getBrandSliderStyles(this.setting && this.setting.theme_primary_color).processStyle;
    },
    tooltipStyle() {
      return getBrandSliderStyles(this.setting && this.setting.theme_primary_color).tooltipStyle;
    },
  },

  methods: {
    //cancel Adding Rooms
    cancelAddingRoom() {
      this.$store.commit("orders/updateRoomVisible", false);
      this.$router.push(
        `/reservation-details/` + this.addingNewRoomReservationId
      );
    },
    isAlreadyBooked(id) {
      return this.bookedRoomsIdList.includes(id);
    },
    SingleRoomView(index, modalName, madalAddroom) {
      this.GetSingleRoomDetails(index);
      if (this.addingNewRoomVisible) {
        this.$refs.AddmoreRoom[0].show(madalAddroom);
      } else {
        this.$refs.RoomSingleModal[0].show(modalName);
      }
    },
    //Get Room Images
    GetSingleRoomImages(index) {
      axios
        .get(`hms/web/rooms/${index}/images`)
        .then((res) => {
          this.RoomImagesData = res.data.data;
        })
        .catch((err) => {});
    },
    // this.dish.types.map((p) => {
    //   this.units.push({
    //     key: p.unit.id,
    //     text: p.unit.name,
    //     price:p.price
    //   });
    //   this.dish.units = this.units;
    // });
    // }

    //Get Room Types
    GetSingleRoomTypes(RoomsData) {
      this.RoomTypesData = RoomsData.types;
    },

    GetSingleRoomDetails(index) {
      this.GetSingleRoomImages(index);

      axios
        .get(`hms/rooms/${index}`)
        .then((res) => {
          this.roomsDatasingleView = res.data;
          this.GetSingleRoomTypes(res.data);
        })
        .catch((err) => {});
    },

    RefreshData() {
      this.GetRooms();
    },

    FilterRooms() {
      axios
        .get(
          `hms/web/rooms/avilable-rooms?start=${this.FilterDate.start}&end=${this.FilterDate.end}`
        )
        .then((res) => {
          this.roomsData = res.data;

          this.typesLoaded = true;
        })
        .catch((err) => {});
    },
    SearchRoom() {
      axios
        .get(
          `hms/web/rooms/avilable-rooms?start=${this.FilterDate.start}&end=${this.FilterDate.end}&query=${this.searchroom}`
        )
        .then((res) => {
          this.roomsData = res.data;

          this.typesLoaded = true;
        })
        .catch((err) => {});
    },

    GetRoomTypes() {
      axios
        .get(`hms/room-types`)
        .then((res) => {
          this.roomTypes = res.data.data;
          this.typesLoaded = true;
        })
        .catch((err) => {});
    },
  },
  created() {
    this.GetRoomTypes();
    this.FilterRooms();
  },
};
</script>

<style lang="scss" scoped>
.cancelbutton {
  padding: 0 14px;
  min-width: 180px;
  background: #d32f2f;
  outline: none;
  border-radius: 20px;
  border: none;
  color: white !important;
  height: 35px !important;
}

.rooms-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
}
.rooms-topbar__left {
  flex: 1;
  min-width: 220px;
}
.rooms-topbar__right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}
.rooms-search {
  height: 38px;
  border-radius: 10px;
}

.bg {
  background-size: contain;
}

#Home {
  img {
    max-width: 400px;
  }
}

.info2 {
  position: absolute;
  background-color: black;
  background-color: #4ccc2c !important;
  left: 15px;
  top: 40px !important;
}

.strip figure {
  height: 190px;
}

.room-strip {
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  transition: transform 180ms ease, box-shadow 180ms ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.room-strip:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.12);
}
.room-strip figure {
  margin: 0;
  position: relative;
  height: 190px;
}
.room-strip figure img,
.room-strip figure :deep(.swiper),
.room-strip figure :deep(.swiper-wrapper),
.room-strip figure :deep(.swiper-slide) {
  height: 100% !important;
}
.room-strip figure img {
  width: 100%;
  object-fit: cover;
  display: block;
}
.strip_info {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 12px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.55) 70%,
    rgba(0, 0, 0, 0.7) 100%
  );
}
.room-name {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.2px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45);
}

.room-strip ul {
  margin: 0;
  padding: 12px 12px 14px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.room-meta {
  display: grid;
  grid-template-columns: 78px 1fr;
  align-items: start;
  gap: 8px;
  font-size: 13px;
  line-height: 1.2;
}
.room-meta__label {
  color: #6b7280;
  font-weight: 600;
}
.room-meta__value {
  color: #111827;
}
.room-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f3f4f6;
  border: 1px solid rgba(17, 24, 39, 0.06);
  border-radius: 999px;
  padding: 2px 8px;
  font-weight: 600;
  font-size: 12px;
  margin-right: 6px;
  margin-bottom: 6px;
}
.room-actions {
  margin-top: auto;
}
.room-cta {
  width: 100%;
  border: none;
  height: 40px;
  border-radius: 12px;
  background: #0f9d58;
  color: #fff !important;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: filter 160ms ease, transform 160ms ease, opacity 160ms ease;
}
.room-cta:hover {
  filter: brightness(0.98);
  transform: translateY(-1px);
}
.room-cta--disabled,
.room-cta:disabled {
  opacity: 0.6;
  background: #6b7280;
  cursor: not-allowed;
  transform: none;
}
</style>
<style scoped>
nav.float-action-button[data-v-6b92200b] {
  z-index: 999;
}

.margin_30_40 {
  min-height: 80vh;
}

.vm--modal {
  position: relative;
  overflow: visible !important;
  box-sizing: border-box;
  background-color: white;
  border-radius: 3px;
  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
}

.modal_header,
.modal_footer {
  width: 100% !important;

  left: 0px !important;
}

* {
  list-style: none;
}

.booked {
  filter: grayscale(1);
}

.checkout {
  width: 44px;
  height: 44px;
  color: #1f2937;
  background-color: #ffffff;
  border-radius: 999px;
  border: 1px solid rgba(17, 24, 39, 0.08);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.checkout:active {
  width: 44px;
  height: 44px;
  color: #1f2937 !important;
  background-color: #ffffff !important;
  border-radius: 999px;
}

.checkout__count {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: #ef4444;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
